import styled from "styled-components";

export const StyledButton = styled.button`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.color.major};
  color: ${({ theme }) => theme.color.white};
  ${({ theme }) => theme.font.small_bold};
  border-radius: 8px;
  font-size: 12px;
`;
